module.exports = __webpack_public_path__ + "bh.svg?84a05269aac00c7bf0ed958fe3f950df";